// extracted by mini-css-extract-plugin
module.exports = {"ReportTitle":"Page_ReportTitle__h6myM","MainWrapper":"Page_MainWrapper__kVzTq","CompleteButton":"Page_CompleteButton__n_4LH"};